export const START_TIMER = "START_TIMER";
export const COUNTDOWN_TIMER = "COUNTDOWN_TIMERR";
export const CHANGE_TIMER_STATUS = "CHANGE_TIMER_STATUS";
export const PAUSE_TIMER = "PAUSE_TIMER";
export const RESET_TIMER = "RESET_TIMER";
export const RESTORE_TIMER = "RESTORE_TIMER";

export const CHANGE_NOTIFICATION_STATUS = "CHANGE_NOTIFICATION_STATUS";
export const CHANGE_WAKE_LOCK_STATUS = "CHANGE_WAKE_LOCK_STATUS";
export const CHANGE_SOUND_STATUS = "CHANGE_SOUND_STATUS";
export const CHANGE_VIBRATION_STATUS = "CHANGE_VIBRATION_STATUS";

export const RESET_TIMER_SETTINGS = "RESET_TIMER_SETTINGS";

export const UPDATE_WORK_MINUTES = "UPDATE_WORK_MINUTES";
export const UPDATE_SHORT_BREAK_MINUTES = "UPDATE_SHORT_BREAK_MINUTES";
export const UPDATE_LONG_BREAK_MINUTES = "UPDATE_LONG_BREAK_MINUTES";
export const UPDATE_TOTAL_TIME = "UPDATE_TOTAL_TIME";

export const PLAY_SOUND = "PLAY_SOUND";
export const PREPARE_SOUND = "PREPARE_SOUND";

export const PLAY_VIBRATION = "PLAY_VIBRATION";

export const UPDATE_WEBHOOK_METHOD = "UPDATE_WEBHOOK_METHOD";
export const UPDATE_WEBHOOK_URL = "UPDATE_WEBHOOK_URL";
export const UPDATE_WEBHOOK_HEADERS = "UPDATE_WEBHOOK_HEADERS";
export const UPDATE_WEBHOOK_DATA = "UPDATE_WEBHOOK_DATA";
export const RESET_WEBHOOK_SETTINGS = "RESET_WEBHOOK_SETTINGS";
